"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function classNameForSectionAlignment(alignment) {
    return constants_1.SECTION_BASE_CLASS_NAME + "--align-" + alignment;
}
exports.classNameForSectionAlignment = classNameForSectionAlignment;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/toolbar/lib/utils.js
// module id = ./node_modules/@react-mdc/toolbar/lib/utils.js
// module chunks = 2